var $ = require('core-js/internals/export.js');

// `reportError` method
// https://html.spec.whatwg.org/multipage/webappapis.html#dom-reporterror
$(
  { global: true, enumerable: true, dontCallGetSet: true },
  {
    reportError: function (error) {
      setTimeout(function () {
        throw error;
      }, 0);
    },
  }
);
